require('jquery-deparam/jquery-deparam');
require('bootstrap-datepicker/dist/js/bootstrap-datepicker.min');
require('bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css');

var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var PersonsCollection = require('../../collections/persons-collection');
var Pager = require('../pager/pager-view.js');

var CommonUtils = require('../../utils/common-utils.js');
var Constants = require('../../utils/constants');


var PatientsRowView = Marionette.View.extend({
    tagName: 'tr',
    template: require('../../templates/patients/patients-row.html'),
    events: {},

    templateContext: function () {
        var that = this;
        var birthDate = that.model.get('object').birthData;
        return {
            age: (birthDate == '' || birthDate == 0 ? '-' : (new Date().getFullYear() - new Date(birthDate).getFullYear()))
        }
    },

    initialize: function (options) {
        //_.bindAll(this, 'removePermission', 'onChecked');
    }
});

var EmptyView = Marionette.View.extend({
    tagName: 'tr',
    template: _.template(_.reduce(_.map(_.range(2), function (value) {
        return '<td>-</td>'
    }), function (memo, str) {
        return memo + str;
    }, ""))
});

var PatientsTableBody = Marionette.CollectionView.extend({
    tagName: 'tbody',
    childView: PatientsRowView,
    emptyView: EmptyView,

    collectionEvents: {
        request: 'showLoading',
        sync: 'hideLoading',
        error: 'logError'
    },

    childViewEvents: {},

    initialize: function (options) {
        _.bindAll(this, 'showLoading', 'hideLoading', 'logError');
        this.collection = options.collection;
    },

    childViewOptions: function () {
        return {};
    },

    showLoading: function () {
        this.$('.loading').show();
    },

    hideLoading: function () {
        this.$('.loading').hide();
    },

    logError: function (obj, response) {
        this.$('.loading').hide();
        this.triggerMethod('server:error', response.responseText);
    }
});

var PatientsView = Marionette.View.extend({
    tagName: 'div',
    className: 'patients-table',
    template: require('../../templates/patients/patients-view.html'),

    regions: {
        body: {
            el: 'tbody',
            replaceElement: true
        },
        pager: '#pager'
    },

    ui: {
        filter: '#filter',
        clearFilter: '#clear-filter',
        patientName: '#patient-name',
        birthDate: '#birth-date',
        burnAfter: '#burn-after',
        burnBefore: '#burn-before'
    },

    events: {
        'click @ui.filter': 'doFilter',
        'click @ui.clearFilter': 'doClearFilter'
    },

    childViewEvents: {},

    templateContext: function () {
        var that = this;
        return {
            getParam: function (key) {
                return that.params[key];
            },
            getDateParam: function (key) {
                if (that.params[key]) {
                    try {
                        return that.utils.longToDateTimeFormatted(Number(that.params[key]), 'MM/DD/YYYY');
                    } catch (e) {
                        console.log(e);
                        return undefined;
                    }
                }
                return undefined;
            }
        }
    },

    onRender: function () {
        window.document.title = "RNS Patients";
        var that = this;
        that.ui.birthDate.datepicker({
            format: 'mm/dd/yyyy',
            clearBtn: true
        }).on('changeDate', function (e) {
            $(this).datepicker('hide');
        });
        that.ui.burnAfter.datepicker({
            format: 'mm/dd/yyyy',
            clearBtn: true
        }).on('changeDate', function (e) {
            $(this).datepicker('hide');
        });
        that.ui.burnBefore.datepicker({
            format: 'mm/dd/yyyy',
            clearBtn: true
        }).on('changeDate', function (e) {
            $(this).datepicker('hide');
        });

        that.collection = new PersonsCollection([],
            {params: that.utils.mergeCollectionParams(that.defaultCollectionParams, that.utils.queryParamsToCollection(that.params) || [])});
        that.collection.fetch({
            success: function () {
                that.showChildView('body', new PatientsTableBody({
                    collection: that.collection
                }));

                that.showChildView('pager', new Pager({
                    baseCountUrl: '/api/person/count?object_isPatient=true&object_mergeable=false'
                }));
            }
        });

        if (that.utils.isUrlWoExtraQueryParameters()) {
            that.ui.clearFilter.hide();
        } else {
            that.ui.clearFilter.show();
        }
    },

    initialize: function (options) {
        var that = this;
        _.bindAll(that, 'doFilter', 'doClearFilter');
        that.utils = new CommonUtils();
        that.params = $.deparam(window.location.hash.replace('#patients', '').replace('?', ''));
        that.defaultListParams = that.utils.getDefaultListParams();
        that.initDefaultCollectionParams()
    },

    initDefaultCollectionParams: function () {

        this.defaultCollectionParams = [
            {key: 'sortby', value: 'name'},
            {key: 'sortdir', value: 'ASC'},
            {key: 'page-size', value: Constants.pageCapacity},
            {key: 'object_isPatient', value: true},
            {key: 'object_mergeable', value: false}
        ]
    },

    doFilter: function () {
        var that = this;

        if (that.ui.patientName.val() != undefined && that.ui.patientName.val() != '')
            that.defaultListParams['like_name'] = that.ui.patientName.val();
        else
            delete (that.defaultListParams['like_name']);

        if (that.ui.birthDate.val() != undefined && that.ui.birthDate.val() != '')
            that.defaultListParams['object_birthData_date'] = that.utils.dateToLong(that.ui.birthDate.val());
        else
            delete (that.defaultListParams['object_birthData_date']);

        if (that.ui.burnAfter.val() != undefined && that.ui.burnAfter.val() != '')
            that.defaultListParams['object_birthData_from'] = that.utils.dateToLong(that.ui.burnAfter.val());
        else
            delete (that.defaultListParams['object_birthData_from']);

        if (that.ui.burnBefore.val() != undefined && that.ui.burnBefore.val() != '')
            that.defaultListParams['object_birthData_to'] = that.utils.dateToLong(that.ui.burnBefore.val());
        else
            delete (that.defaultListParams['object_birthData_to']);

        that.defaultListParams.page = 0;

        window.location.hash = that.utils.getCleanBaseHash() + "?" + that.utils.objectToQueryParams(that.defaultListParams);
    },

    doClearFilter: function () {
        this.utils.redirectToUrlWoExtraQueryParameters();
    }
});

module.exports = PatientsView;


//////////////////
// WEBPACK FOOTER
// ./app/views/patients/patients.js
// module id = 460
// module chunks = 0